export const styles = {
  buttonCopy: {
    color: 'primary.600',
  },
};
